import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import { css } from "../../../lib/theming/Emotion";
export var tokenSizeMixin = function tokenSizeMixin(tokenPaddingY, tokenPaddingX, lineHeight, fontSize, tokenMarginY, tokenMarginX) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    padding: ", " ", ";\n    margin: ", " ", ";\n    line-height: ", ";\n    font-size: ", ";\n  "])), tokenPaddingY, tokenPaddingX, tokenMarginY, tokenMarginX, lineHeight, fontSize);
};